var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.blocks),function(block){return [_c('block',{key:block.id,attrs:{"block":block,"step":_vm.step},on:{"change":_vm.getBlocks}})]}),_c('add-block',{attrs:{"step":_vm.step},on:{"add":_vm.getBlocks}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }